import styled from 'styled-components';

import ZIndexLayers from '../../services/ZIndexLayers';
import { ThemeProp } from '../../theme/Themes';

export const TrackContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 1rem;
  position: relative;
  flex: 1;
`;

export const Track = styled.div`
  height: 0.5rem;
  width: calc(100% - 1rem);
  border-radius: 0.25rem;
  align-self: center;
`;

export const Thumb = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1rem;
  width: 1rem;
  border-radius: 3.125rem;
  background: ${(props: ThemeProp) => props.theme.colors.main.c600};
  outline-style: none;
  z-index: ${ZIndexLayers.overlay} !important;
`;

interface StartEndDecoratorProps {
  $start?: boolean;
  $isOnlyOneThumb?: boolean;
}
export const StartEndDecorator = styled.div<StartEndDecoratorProps>`
  width: 0.75rem;
  height: 0.5rem;
  border-radius: 0.25rem;
  background: ${(props: ThemeProp & StartEndDecoratorProps) =>
    props.$start && props.$isOnlyOneThumb ? props.theme.colors.main.c300 : props.theme.colors.neutrals.c100};

  position: absolute;
  ${(props: StartEndDecoratorProps) => (props.$start ? 'left: 2px;' : 'right: 2px;')}
  z-index: ${ZIndexLayers.elevateOne} !important;
`;
